import React from "react";

import ForgotPassword from "./ForgotPassword";

const ForgotPasswordContainer = () => {
    return (
        <ForgotPassword />
    )
}

export default React.memo(ForgotPasswordContainer);